export default __webpack_public_path__ + "static/media/landzilla-logo.4f46acfc.svg";